import React, { useEffect, useRef } from 'react';

const EsencaSizingPlugin = ({ 
  config = {}, 
  theme = 'light', 
  language = 'en', 
  apiKey, 
  width, 
  height,
  onReady,
  onUpdated,
  onUpdateAvailable,
  onSizeSelect,
  ...props 
}) => {
  const containerRef = useRef(null);
  const pluginRef = useRef(null);

  useEffect(() => {
    // Ensure the web component is loaded
    if (!window.customElements.get('esenca-sizing-web-plugin')) {
      console.warn('Esenca Sizing Plugin web component not loaded');
      return;
    }

    // Create the web component
    const plugin = document.createElement('esenca-sizing-web-plugin');
    
    // Set config as JSON string
    if (config && Object.keys(config).length > 0) {
      plugin.setAttribute('config', JSON.stringify(config));
    }

    // Set individual attributes
    if (theme) plugin.setAttribute('theme', theme);
    if (language) plugin.setAttribute('lang', language);
    if (apiKey) plugin.setAttribute('api-key', apiKey);
    if (width) plugin.setAttribute('width', width);
    if (height) plugin.setAttribute('height', height);

    if (onSizeSelect) {
      plugin.onSizeSelect = onSizeSelect;
    }

    // Add event listeners
    const handleReady = (event) => {
      console.log('Plugin ready:', event.detail);
      onReady?.(event.detail);
    };

    const handleUpdated = (event) => {
      console.log('Plugin updated:', event.detail);
      onUpdated?.(event.detail);
    };

    const handleUpdateAvailable = (event) => {
      console.log('Update available:', event.detail);
      onUpdateAvailable?.(event.detail);
    };

    plugin.addEventListener('plugin-ready', handleReady);
    plugin.addEventListener('plugin-updated', handleUpdated);
    plugin.addEventListener('plugin-update-available', handleUpdateAvailable);

    // Add to DOM
    if (containerRef.current) {
      containerRef.current.appendChild(plugin);
      pluginRef.current = plugin;
    }

    // Cleanup function
    return () => {
      if (pluginRef.current) {
        pluginRef.current.removeEventListener('plugin-ready', handleReady);
        pluginRef.current.removeEventListener('plugin-updated', handleUpdated);
        pluginRef.current.removeEventListener('plugin-update-available', handleUpdateAvailable);
        
        if (containerRef.current && containerRef.current.contains(pluginRef.current)) {
          containerRef.current.removeChild(pluginRef.current);
        }
      }
    };
  }, [config, theme, language, apiKey, width, height, onReady, onUpdated, onUpdateAvailable]);

  // Update config when props change
  useEffect(() => {
    if (pluginRef.current && config) {
      pluginRef.current.updateConfig(config);
    }
  }, [config]);

  return (
    <div 
      ref={containerRef} 
      className="esenca-sizing-plugin-container"
      {...props}
    />
  );
};

export default EsencaSizingPlugin;